import React from 'react';
import { connect } from 'react-redux';
import { Table, Icon } from 'antd';

import { setSitesFromServer, setBrowserData } from '../../actions';
import { selectedSiteId, selectedDirectory } from '../../actions/selectedElement';
import { backForwardDirectory } from '../../actions/backForward';

import requestAPI from '../../helpers/requestAPI';
import arrayRecurcive from '../../helpers/arrayRecursive';
import addPropsToDirsAndFiles from '../../helpers/addPropsToDirsAndFiles';

import './filesBrowser.scss';

const FilesBrowser = ({
	browserData,
	selectedElements,
	setSelectedElements,
	sitesFromServer,
	backForward,
	setFiles,
	setData,
	selectingSiteId,
	selectingDirectoryPath,
	backForwardDirectory
}) => {
	const [ selectedIdElement, setSelectedIdElement ] = React.useState(null);

	const columns = [
		{
			title: 'Name',
			dataIndex: 'name',
			key: 'name',
			width: '60%',
			sorter: (a, b) => {
				return a.name.localeCompare(b.name);
			},
			render: (name, record) => (
				<div>
					<Icon type={record.isFolder ? 'folder' : 'file'} />
					{name}
				</div>
			)
		},
		{
			title: 'Size',
			dataIndex: 'size',
			key: 'size',
			sorter: (a, b) => a.size - b.size
		},
		{
			title: 'Last modify',
			dataIndex: 'lastMod',
			key: 'lastMod',
			sorter: (a, b) => new Date(a.lastMod) - new Date(b.lastMod)
		}
	];

	const handleDoubleClick = (record) => {
		if (!record.isFolder) return;

		const clickedDirPath = record.directory === '/' ? record.name : record.directory + '/' + record.name;

		selectingSiteId(record.siteId);
		selectingDirectoryPath(clickedDirPath);

		const backForwardData = {
			back: [ ...backForward.back, { siteId: record.siteId, directory: clickedDirPath } ],
			forward: []
		};

		if (
			backForward.back.length === 0 ||
			backForward.back[backForward.back.length - 1].directory !== clickedDirPath ||
			backForward.back[backForward.back.length - 1].siteId !== record.siteId
		) {
			backForwardDirectory(backForwardData);
		}

		const siteName = sitesFromServer.find((item) => item.title === record.siteId).label;
		const params = {
			routeParams: {
				route: 'dir'
			},
			additionalQueryStringParams: {
				site_id: record.siteId,
				directory: clickedDirPath
			}
		};

		requestAPI(params).then((response) => {
			const dirs = addPropsToDirsAndFiles(response, siteName, setData, record.siteId).dirs;
			const currentDirUrl = response.data.data.current_directory;
			const pathArray = [ siteName, ...currentDirUrl.split('/') ];
			const newData = JSON.parse(JSON.stringify(sitesFromServer));

			arrayRecurcive(newData, dirs, pathArray); //adding new data to treeData
			setFiles(newData);
		});
	};

	const handleClick = (e, record) => {
		e.stopPropagation();
		if (e.ctrlKey || e.metaKey) {
			if (selectedElements.findIndex((i) => i.name === record.name) < 0) {
				if (selectedElements.length <= 0) {
					setSelectedIdElement(record.key);
				}
				setSelectedElements([ ...selectedElements, { name: record.name, isFolder: record.isFolder } ]);
			} else {
				const positionUnselectedElement = selectedElements.findIndex((i) => i.name === record.name);

				setSelectedElements(
					selectedElements.filter((elem, i) => {
						return i !== positionUnselectedElement;
					})
				);

				if (selectedElements.length  === 1) {
					setSelectedIdElement(null);
				}
			}
		} else if (e.shiftKey) {
			if (selectedIdElement !== null) {
				const spliceParams =
					selectedIdElement < record.key ? [ selectedIdElement, record.key ] : [ record.key, selectedIdElement ];
				let arr = [];
				browserData.forEach((elem, j) => {
					if (j >= spliceParams[0] && j <= spliceParams[1]) {
						arr.push({ name: elem.label, isFolder: JSON.parse(elem.value).isFolder });
					}
				});
				setSelectedElements(arr);
			}
		} else {
			setSelectedElements([ { name: record.name, isFolder: record.isFolder } ]);
			setSelectedIdElement(record.key);
		}
	};

	const renderItems = () => {
		if (Object.keys(browserData).length === 0) return;

		if (browserData[0].label === '..') {
			browserData.shift();
		}

		const data = browserData.map((item, i) => {
			const value = JSON.parse(item.value);
			const itemSize = value.size;
			const itemModify = value.modify;
			const className =
				selectedElements.findIndex((i) => i.name === item.label) >= 0
					? 'files-browser__items__item selected-files-browser__items__item'
					: 'files-browser__items__item';

			return {
				key: i,
				name: item.label,
				size: itemSize,
				lastMod: itemModify,
				isFolder: value.isFolder,
				siteId: value.siteId,
				directory: value.directory,
				className
			};
		});

		return data;
	};

	const handleClickAway = () => {
		setSelectedElements([]);
	};

	return (
		<div className="files-browser" onClick={handleClickAway}>
			<Table
				tableLayout={'auto'}
				dataSource={renderItems()}
				columns={columns}
				pagination={false}
				size={'small'}
				rowClassName={(record) => {
					return record.className;
				}}
				scroll={{ y: 'calc(100vh - 43px - 50px - 41px - 48px)' }} //43px - header, 50px - filebrowser panel, 41px - table header, 48px - nav header
				onRow={(record) => {
					return {
						onClick: (e) => {
							handleClick(e, record);
						}, // click row
						onDoubleClick: () => {
							handleDoubleClick(record);
						}
					};
				}}
			/>
		</div>
	);
};

const mapStateToProps = (state) => {
	return {
		sitesFromServer: state.sites.sitesFromServer,
		backForward: state.navigation.backForward
	};
};

const mapDispatchToProps = (dispatch) => ({
	setFiles: (allSites) => dispatch(setSitesFromServer(allSites)),
	setData: (data) => dispatch(setBrowserData(data)),
	selectingSiteId: (data) => dispatch(selectedSiteId(data)),
	selectingDirectoryPath: (data) => dispatch(selectedDirectory(data)),
	backForwardDirectory: (data) => dispatch(backForwardDirectory(data))
});

export default connect(mapStateToProps, mapDispatchToProps)(FilesBrowser);
